import { Box, Grid, Typography, Button } from '@mui/material';
import React from 'react';
import Profile from '../../../Assets/profile1.png';

const style = {
  position: 'absolute' as 'absolute',
  top: '40%',
  left: '80%',
  transform: 'translate(-50%, -50%)',
  width: { md: 420, lg: 420, xl: 420, xxl: 500 },
  bgcolor: 'background.paper',
  p: 4,
  borderRadius: '9px',
};
const notificationData = [
  {
    name: 'Thomas James',
    subTitle: 'Entrepreneur of the month Jan 2024',
    img: Profile,
    timing: '8 mins ago',
  },
  {
    name: 'Workshop: Working with Designers and PMs',
    subTitle: '4 new registrations for “Workshop: Working with designers and PMs”',
    timing: '8 mins ago',
    img: Profile,
  },
  {
    name: 'Half yearly exams',
    subTitle: 'Entrepreneur of the month Jan 2024',
    timing: '8 mins ago',
    img: Profile,
  },
];
const NotificationModal = (props: any) => {
  return (
    <div>
      <Box sx={style}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>Notifications</Typography>
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end', color: '#2C58E8', cursor: 'pointer', fontWeight: 500, fontSize: '10.5px' }} onClick={() => props.handleClose()}>
            Mark all as read
          </Grid>
        </Grid>
        <Grid container spacing={1} mt={0.5}>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
            <Button
              sx={{
                height: '30px',
                width: '100%',
                backgroundColor: '#2C58E8',
                '&:hover': {
                  backgroundColor: '#2C58E8',
                  color: 'white',
                },
                color: 'white',
                fontSize: '12px',
                fontWeight: '500',
              }}
            >
              All
            </Button>
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
            <Button
              sx={{
                height: '30px',
                width: '100%',
                backgroundColor: '#EAEFFF',
                '&:hover': {
                  backgroundColor: '#EAEFFF',
                  color: '#2C58E8',
                },
                color: '#2C58E8',
                fontSize: '12px',
                fontWeight: '500',
              }}
            >
              Unread
            </Button>
          </Grid>{' '}
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
            <Button
              sx={{
                height: '30px',
                width: '100%',
                backgroundColor: '#EAEFFF',
                '&:hover': {
                  backgroundColor: '#EAEFFF',
                  color: '#2C58E8',
                },
                color: '#2C58E8',
                fontSize: '12px',
                fontWeight: '500',
              }}
            >
              read
            </Button>
          </Grid>
        </Grid>
        <Typography
          sx={{
            fontSize: '10px',
            fontWeight: 400,
            textAlign: 'center',
            mt: 1,
          }}
        >
          Today
        </Typography>
        {notificationData.map((val: any, index: number) => {
          return (
            <>
              <Grid container spacing={2} sx={{ mt: index == 0 ? 1 : 0 }}>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
                  <Box sx={{ height: '42px', width: '42px' }}>
                    <img src={val.img} height={'100%'} width={'100%'} />
                  </Box>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7} xxl={6.5}>
                  <Typography sx={{ color: '#2C58E8', fontWeight: 500, fontSize: '12px' }}>{val.name}</Typography>
                  <Typography sx={{ fontWeight: 400, fontSize: '11px', mt: 0.5 }}>{val.subTitle}</Typography>
                </Grid>
                <Grid item xs={3} sm={3} md={3} lg={3} xl={3} xxl={3.5}>
                  <Box sx={{ display: 'flex' }}>
                    <Button
                      sx={{
                        height: '20px',
                        width: '3vw',
                        borderRadius: '8px',
                        padding: 0,
                        minWidth: '3vw',
                        backgroundColor: '#2C58E8',
                        '&:hover': {
                          backgroundColor: '#2C58E8',
                          color: 'white',
                        },
                        color: 'white',
                        fontSize: '8px',
                        fontWeight: '500',
                      }}
                    >
                      Accept
                    </Button>
                    <Button
                      sx={{
                        height: '20px',
                        width: '3vw',
                        ml: 0.5,
                        backgroundColor: '#EAEFFF',
                        padding: 0,
                        minWidth: '3vw',
                        borderRadius: '8px',
                        '&:hover': {
                          backgroundColor: '#EAEFFF',
                          color: '#2C58E8',
                        },
                        color: '#2C58E8',
                        fontSize: '8px',
                        fontWeight: '500',
                      }}
                    >
                      Decline
                    </Button>
                  </Box>
                  <Typography sx={{ fontWeight: 400, fontSize: '10px', mt: 0.5, textAlign: 'end' }}>{val?.timing}</Typography>
                </Grid>
              </Grid>
              <hr style={{ border: '1px solid #E6E6E8' }} />
            </>
          );
        })}
      </Box>
    </div>
  );
};

export default NotificationModal;
